import type { CmsApiSplitContentBlockData } from '#/modules/cms/api/types/blocks/CmsApiSplitContentBlock';
import type { CmsBlockMapping } from '#/modules/cms/blocks/CmsBlockMapping';
import { CmsMappedBlockWidth } from '#/modules/cms/mappers/CmsMappedBlockWidth';

import { CmsSplitContentBlock } from './CmsSplitContentBlock';

export const CmsSplitContentBlockMapping: CmsBlockMapping<CmsApiSplitContentBlockData> =
  {
    invariant: [],
    width: CmsMappedBlockWidth.NARROW,
    Component: CmsSplitContentBlock,
  };
